module.exports = __webpack_public_path__ + "static/media/0010.4cd21265.jpg";